export const appConfig = {
  apiBaseUrl:
    import.meta.env.MODE === 'development'
      ? 'http://localhost:8173'
      : window.config.apiBaseUrl,
}
